import { projectsStore } from 'stores/projects';
import { $api } from '.';
import { ICryptoProject, TUpdateCryptoProjectForm } from 'types/cryptoProject';
import { notify } from 'hooks/useToast/notify';

export class ProjectsService {
  async fetchProjects() {
    const { setProjects, setTotal, setLoading, page, pageSize, searchQuery, isHidden } =
      projectsStore.getState();

    try {
      setLoading(true);
      const url = `/api/extension/crypto-projects-list?page=${page}&pageSize=${pageSize}&searchQuery=${searchQuery}&isHidden=${isHidden}`;
      const { data } = await $api.get<{ projects: ICryptoProject[]; total: number }>(url);

      setProjects(data.projects);
      setTotal(data.total);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  async toggleHideStatus(twitter: string, isHidden: boolean) {
    const {setLoading } =
    projectsStore.getState();
    setLoading(true);
    const url = '/api/extension/hide-project';
    try {
      await $api.post(url, { twitter: twitter.split('/').pop(), isHidden });
    } catch (error) {
      console.error(error);
    } finally {
      this.fetchProjects();
    }
  }

  async updateProject({id, campaigns }: TUpdateCryptoProjectForm) {
    const { setIsProjectOnEdit } = projectsStore.getState();

    try {
      setIsProjectOnEdit(true);
      const url = `/api/extension/crypto-projects/${id}`;
      const payload = {
        id,
        campaigns: campaigns.map((campaign) => ({
          banner: campaign.banner,
          link: campaign.link,
          ...(campaign.id ? { id: campaign.id } : {}),
        })),
      }
      await $api.put(url, payload);
      notify({
        type: 'success',
        meassage: 'Project updated successfully',
      });
      await this.fetchProjects();
    } catch (error) {
      console.error(error);
    } finally {
      setIsProjectOnEdit(false);
    }
  }

  openEditProjectForm(project: ICryptoProject) {
    const { setProjectToEdit } = projectsStore.getState();
    setProjectToEdit(project);
  }

  closeEditProjectForm() {
    const { setProjectToEdit } = projectsStore.getState();
    setProjectToEdit(null);
  }
}

export const projectsService = new ProjectsService();
